var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-label-table',{staticClass:"pt-label-table__withData",attrs:{"tableData":_vm.tableData,"totalNumber":_vm.totalNumber,"pageSize":_vm.pageSize,"tableLabels":_vm.tableLabels},on:{"getTableData":_vm.getTableData}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }